import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

// laravel-echo reads the constructor off the global rather than taking it as an
// option, so the assignment below needs the global to be declared.
declare global {
  interface Window {
    Pusher: typeof Pusher;
  }
}

// Make Pusher available globally for Laravel Echo
window.Pusher = Pusher;

// Configure Echo with Soketi
const echo = new Echo({
  broadcaster: 'pusher',
  key: import.meta.env.VITE_SOKETI_KEY,
  wsHost: import.meta.env.VITE_SOKETI_HOST,
  wsPort: import.meta.env.VITE_SOKETI_PORT,
  wssPort: import.meta.env.VITE_SOKETI_PORT,
  forceTLS: false,
  encrypted: false,
  disableStats: true,
  enabledTransports: ['ws', 'wss'],
  cluster: import.meta.env.VITE_SOKETI_CLUSTER || 'mt1',
  authEndpoint: import.meta.env.VITE_PUSHER_AUTH_ENDPOINT,
  auth: {
    headers: {
      get Authorization() {
        return `Bearer ${localStorage.getItem('token')}`;
      },
    },
  },
});

export default echo;
